import React from "react";
import { INTERACTIVE_CLASSES } from "../../../interactive-product-classes";
import { getSvgMaskStyleFromUrl } from "../../../utils/svg-utils";

export const getButtonContentFromImages = ({
	buttonImageSrc,
	maskImageSrc,
	contentClass = undefined,
	imgAlt = undefined,
}) => {
	const hasImageSrc = buttonImageSrc !== undefined;
	const hasSvgMaskSrc = maskImageSrc !== undefined;

	const hasBoth = hasImageSrc && hasSvgMaskSrc;

	if (hasBoth) {
		console.error("Both imageSrc and svgMaskSrc are provided. Only one of them should be provided");
		return null;
	}

	if (hasImageSrc) {
		return <img src={buttonImageSrc} className={contentClass} alt={imgAlt} />;
	} else if (hasSvgMaskSrc) {
		const svgStyle = getSvgMaskStyleFromUrl(maskImageSrc);
		return <div style={svgStyle} className={contentClass} />;
	}

	console.error("Either imageSrc or svgMaskSrc must be provided");
	return null;
};

export const getButtonModifierClasses = ({
	colorful = false,
	colorfulActive = false,
	disabled = false,
}) => {
	const usedColorClass = colorful
		? INTERACTIVE_CLASSES.BUTTON_WRAPPER_ICON_COLORFUL_MOD
		: "";

	const activeClass = colorfulActive
		? INTERACTIVE_CLASSES.BUTTON_WRAPPER_ICON_COLORFUL_ACTIVE_MOD
		: "";

	const disabledClass = disabled
		? INTERACTIVE_CLASSES.BUTTON_WRAPPER_DISABLED_MOD
		: "";

	return {
		usedColorClass,
		activeClass,
		disabledClass,
	};
};
